'use strict';

wbApp.factory('uiUtilsSvc', [
    function () {

        var scrollbarWidth = 0;
        var scrollbarWidthSet = false;

        function getScrollbarWidth() {
            if (!scrollbarWidthSet) {
                // Create the measurement node
                var scrollDiv = document.createElement("div");
                scrollDiv.className = "scrollbar-measure";
                document.body.appendChild(scrollDiv);

                // Get the scrollbar width
                scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
                scrollbarWidthSet = true;

                // Delete the DIV 
                document.body.removeChild(scrollDiv);
            }

            return scrollbarWidth;
        }


        return {
            getScrollbarWidth: getScrollbarWidth
        }
    }
]);